// Authentication utility functions
export const AUTH_TOKEN_KEY = "authToken";
export const USER_DATA_KEY = "user";

// Get authentication token from localStorage
export const getAuthToken = () => {
  return (
    localStorage.getItem(AUTH_TOKEN_KEY) ||
    sessionStorage.getItem(AUTH_TOKEN_KEY)
  );
};

// Set authentication token in localStorage
export const setAuthToken = (token) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

// Remove authentication token
export const removeAuthToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
};

// Get user data from localStorage
export const getUserData = () => {
  const userData = localStorage.getItem(USER_DATA_KEY);
  return userData ? JSON.parse(userData) : null;
};

// Set user data in localStorage
export const setUserData = (userData) => {
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData));
};

// Remove user data
export const removeUserData = () => {
  localStorage.removeItem(USER_DATA_KEY);
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getAuthToken();
};

// Get user role
export const getUserRole = () => {
  const userData = getUserData();
  return userData?.role || null;
};

// Logout user (clear all auth data)
export const logout = () => {
  removeAuthToken();
  removeUserData();
  localStorage.removeItem("selectedPackageId");
  localStorage.removeItem("isCardSaved");
};

// Check if user has specific role
export const hasRole = (role) => {
  return getUserRole() === role;
};
